import {
  lensPath,
  set,
} from 'ramda';
import { qualifyNewKeyPath } from './utils';

export default (state, domain, key) => {
  const qualifiedPath = qualifyNewKeyPath(domain);
  const lens = lensPath(qualifiedPath);

  return set(lens, key, state);
};
